import script from "./dummyData9.vue?vue&type=script&lang=js"
export * from "./dummyData9.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__